import React from 'react';
import LegalPageLayout, { LegalSection } from '../components/LegalPageLayout';
import { useBrandName } from '../context/SettingsContext';

const Politique = () => {
  const brandName = useBrandName();

  return (
    <LegalPageLayout
      title="Politique de confidentialité"
      subtitle="Comment nous collectons, utilisons et protégeons vos données personnelles (RGPD)."
      badge="RGPD"
      path="/politique-confidentialite"
      lastUpdated="2025-01-15"
      metaDescription={`Politique de confidentialité ${brandName} — collecte, utilisation et protection de vos données personnelles conformément au RGPD.`}
    >
      <LegalSection title="1. Responsable du traitement">
        <p>
          <strong>{brandName}</strong> est responsable du traitement des données personnelles
          collectées via ce site internet et ses formulaires.
        </p>
        <p>
          Pour toute question relative à vos données :{' '}
          <a href="mailto:contact@digirobot.fr">contact@digirobot.fr</a>
        </p>
      </LegalSection>

      <LegalSection title="2. Données collectées">
        <p>Nous collectons les catégories de données suivantes :</p>
        <ul>
          <li><strong>Identité</strong> : nom, prénom</li>
          <li><strong>Coordonnées</strong> : adresse email, numéro de téléphone</li>
          <li><strong>Informations enfant</strong> : prénom, âge (pour l&apos;inscription aux ateliers)</li>
          <li><strong>Données de réservation</strong> : prestation choisie, créneau, centre</li>
          <li><strong>Données de paiement</strong> : traitées exclusivement par Stripe (nous ne stockons pas vos coordonnées bancaires)</li>
          <li><strong>Données de navigation</strong> : cookies techniques, pages visitées (anonymisées)</li>
        </ul>
      </LegalSection>

      <LegalSection title="3. Finalités du traitement">
        <p>Vos données sont utilisées pour :</p>
        <ul>
          <li>Gérer vos réservations et inscriptions aux cursus et stages</li>
          <li>Vous envoyer des confirmations, rappels et informations pratiques</li>
          <li>Répondre à vos demandes via le formulaire de contact</li>
          <li>Vous adresser notre newsletter (avec votre consentement)</li>
          <li>Améliorer nos services et notre site web</li>
          <li>Respecter nos obligations légales et comptables</li>
        </ul>
      </LegalSection>

      <LegalSection title="4. Base légale">
        <p>Le traitement de vos données repose sur :</p>
        <ul>
          <li><strong>L&apos;exécution du contrat</strong> — gestion de votre réservation</li>
          <li><strong>Votre consentement</strong> — formulaires de contact, newsletter</li>
          <li><strong>L&apos;intérêt légitime</strong> — amélioration de nos services, suivi commercial</li>
          <li><strong>L&apos;obligation légale</strong> — conservation comptable</li>
        </ul>
      </LegalSection>

      <LegalSection title="5. Durée de conservation">
        <ul>
          <li>Données de réservation : 5 ans après la fin de la relation contractuelle</li>
          <li>Données de contact non converties : 12 mois maximum</li>
          <li>Données comptables : 10 ans (obligation légale)</li>
          <li>Cookies : durée maximale de 13 mois</li>
        </ul>
      </LegalSection>

      <LegalSection title="6. Vos droits">
        <p>
          Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :
        </p>
        <ul>
          <li>Droit d&apos;accès à vos données</li>
          <li>Droit de rectification</li>
          <li>Droit à l&apos;effacement (« droit à l&apos;oubli »)</li>
          <li>Droit à la limitation du traitement</li>
          <li>Droit à la portabilité</li>
          <li>Droit d&apos;opposition</li>
        </ul>
        <p>
          Pour exercer ces droits, contactez-nous à{' '}
          <a href="mailto:contact@digirobot.fr">contact@digirobot.fr</a>.
          Vous pouvez également introduire une réclamation auprès de la{' '}
          <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">CNIL</a>.
        </p>
      </LegalSection>

      <LegalSection title="7. Cookies">
        <p>
          Ce site utilise des cookies techniques nécessaires au fonctionnement (session, préférences d&apos;affichage).
          Des cookies analytiques peuvent être déposés pour mesurer l&apos;audience du site.
        </p>
        <p>
          Aucun cookie publicitaire ou de profilage n&apos;est déposé sans votre consentement explicite.
          Vous pouvez configurer votre navigateur pour refuser les cookies.
        </p>
      </LegalSection>

      <LegalSection title="8. Sous-traitants">
        <p>
          Nous faisons appel à des prestataires conformes au RGPD pour :
        </p>
        <ul>
          <li><strong>Hébergement</strong> — stockage du site et des données</li>
          <li><strong>Brevo</strong> — envoi d&apos;emails transactionnels et newsletters</li>
          <li><strong>Stripe</strong> — traitement sécurisé des paiements en ligne</li>
        </ul>
        <p>
          Ces sous-traitants n&apos;accèdent qu&apos;aux données strictement nécessaires à leur mission
          et sont contractuellement tenus de les protéger.
        </p>
      </LegalSection>

      <LegalSection title="9. Sécurité">
        <p>
          {brandName} met en œuvre des mesures techniques et organisationnelles appropriées
          pour protéger vos données contre la perte, l&apos;accès non autorisé, la divulgation
          ou la destruction.
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
};

export default Politique;
